<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Secondary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (packageSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Package Size:</label>
            <select
              class="halfWidthInputField"
              #packageSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(packageSizeSelection.Name)"
              (change)="selectionChanged(packageSizeSelection, packageSizeInput.value)"
              [value]="packageSizeSelection.Value.toString()">
              @for (allowable of packageSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="packageSizeSelection.Value && packageSizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (flowControlTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select
              class="halfWidthInputField"
              #flowControlTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(flowControlTypeSelection.Name)"
              (change)="selectionChanged(flowControlTypeSelection, flowControlTypeInput.value)"
              [value]="flowControlTypeSelection.Value.toString()">
              @for (allowable of flowControlTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="flowControlTypeSelection.Value && flowControlTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (controlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select
              class="halfWidthInputField"
              #controlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlValveSelection.Name)"
              (change)="selectionChanged(controlValveSelection, controlValveInput.value)"
              [value]="controlValveSelection.Value.toString()">
              @for (allowable of controlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="controlValveSelection.Value && controlValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (hoseKitSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Hose Kit:</label>
            <select
              class="halfWidthInputField"
              #hoseKitInput
              [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitSelection.Name)"
              (change)="selectionChanged(hoseKitSelection, hoseKitInput.value)"
              [value]="hoseKitSelection.Value.toString()">
              @for (allowable of hoseKitSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="hoseKitSelection.Value && hoseKitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (isolationBallValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select
              class="halfWidthInputField"
              #isolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(isolationBallValveSelection.Name)"
              (change)="selectionChanged(isolationBallValveSelection, isolationBallValveInput.value)"
              [value]="isolationBallValveSelection.Value.toString()">
              @for (allowable of isolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="isolationBallValveSelection.Value && isolationBallValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (normallyOpenSelection) {
          <span class="halfWidthConfigurationInput">
            <label
              [class.invalidConfigurationSelection]="isInvalidSelection(normallyOpenSelection.Name)"
              for="secondaryNormalOpenInput"
              class="halfWidthInputLabel">
              Normally Open
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="secondaryNormalOpenInput"
              #secondaryNormalOpenInput
              [checked]="'true' === normallyOpenSelection.Value"
              (change)="selectionChanged(normallyOpenSelection, secondaryNormalOpenInput.checked.toString())" />
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (serviceFittingsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Service Fittings:</label>
            <select
              class="halfWidthInputField"
              #serviceFittingsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(serviceFittingsSelection.Name)"
              (change)="selectionChanged(serviceFittingsSelection, serviceFittingsInput.value)"
              [value]="serviceFittingsSelection.Value.toString()">
              @for (allowable of serviceFittingsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="serviceFittingsSelection.Value && serviceFittingsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
